<template>
  <div>
    <el-row type="flex">
      <el-col :span="24">
        <ra-card>
          <template slot="header">
            <p>Recent Verifications</p>
            <div class="is-flex is-justify-end">
              <el-button type="primary" size="small" @click="goToVerifications"
                >See all</el-button
              >
            </div>
          </template>
          <template slot="content">
            <el-table
              :data="verifications"
              v-loading="loading"
              :empty-text="noDataMessage"
            >
              <el-table-column prop="Type of ID">
                <template slot="header">
                  <span class="ra-table--header">
                    Type of ID
                  </span>
                </template>
                <template v-slot="scope">
                  <p>
                    {{ scope.row.type }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="Type of ID">
                <template slot="header">
                  <span class="ra-table--header">
                    Type of ID
                  </span>
                </template>
                <template v-slot="scope">
                  <p>
                    {{ scope.row.identifier }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="date">
                <template slot="header">
                  <span class="ra-table--header">
                    Date
                  </span>
                </template>
                <template v-slot="scope">
                  <p>{{ scope.row.date }}</p>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </ra-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";

const paging = {
  perPage: 5,
  currentPage: 1,
  total: 0
};

export default {
  name: "RecentVerifications",
  data() {
    return {
      loading: false,
      verifications: [],
      pagination: { ...paging },
      noDataMessage: "No recent verification(s)",
      verificationServiceId: apiConstants.SERVICE_IDS.VERIFICATION,
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  computed: {
    dataFound() {
      return !!this.pageData.length;
    }
  },

  created() {
    this.loadVerifications();
  },

  methods: {
    goToVerifications() {
      this.$router.push({ name: "verify-identity.verifications" });
    },
    getPaginationParams() {
      const { currentPage, pagination } = this;
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },

    loadVerifications(customParams = "") {
      this.loading = true;
      const params = customParams;
      const apiUrl = "services/logs";

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${params}&${this.getPaginationParams()}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          this.loading = this.loadingClear = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.setVerifications(resData.list);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    setVerifications(data) {
      this.verifications = data.map(verification => {
        const {
          adapterEndpoint,
          identifier,
          created_at,
          status
        } = verification;
        return {
          type:
            adapterEndpoint &&
            adapterEndpoint.endpoint &&
            adapterEndpoint.endpoint.short_name,
          identifier,
          date: this.mFormatDate(created_at, "Do MMM, YYYY"),
          status: status.name
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
